import { SelectedFilterInterface } from "storyblok/components";

//used by VacancyAlert.tsx, EmptyCard.tsx
//requires the full options useState
//returns an array of tuples to be rendered on the page

// takes selectedFilterOptions and makes a separate tuple where every value is paired with its corresponding category
export default function filterTupleMaker(
    filterOptionState: SelectedFilterInterface
) {
    const optionsToRender = [];

    for (const [key, value] of Object.entries(filterOptionState)) {
        //if the value of the current key is an array, make it into an array of tuples where each tuple has its respective key.
        if (Array.isArray(value)) {
            //for each element in the value array, make a tuple that includes the key and the singular element and push it to options to render.
            value.forEach(v => optionsToRender.push([key, v]));
        } else {
            //if the value is a primitive type, just add it to optionsToRender
            optionsToRender.push([key, value]);
        }
    }

    return optionsToRender;
}
